// @ts-check
import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { LoadingComponent } from '../components/loading-component';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import { getOrders } from '../redux/actions/orders-actions';
import { terminateOrder } from '../redux/actions/orders-actions';

import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';

import moment from 'moment';
import Fab from '@material-ui/core/Fab';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';

import { DataGrid, GridToolbar } from '@material-ui/data-grid';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },

  paper: {
    padding: theme.spacing(0),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  heading: {
    margin: theme.spacing(2)
  },
  table: {
    minWidth: 450,
    padding: theme.spacing(0)
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  fab: {
    margin: theme.spacing(0)
  },
  papermodal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

export default function TerminateOrdersPage() {
  // @ts-ignore
  const { id } = useParams();
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [selectedOrder, setSelectedOrder] = React.useState();

  const columns = [
    {
      field: 'order_no',
      headerName: 'Order Number',
      flex: 1
    },
    {
      field: 'created_at',
      headerName: 'Date',
      flex: 1,
      valueGetter: (params) => {
        return moment(params.row.created_at).format('DD-MMM-YYYY HH:mm:ss');
      }
    },
    {
      field: 'hub',
      headerName: 'Hub',
      flex: 1,
      valueGetter: (params) => {
        return params.row.hub.name;
      }
    },
    {
      field: 'branch',
      headerName: 'Branch',
      width: 220,
      valueGetter: (params) => {
        return params.row.branch.name;
      }
    },
    {
      field: ' ',
      headerName: ' ',
      flex: 1,
      renderCell: (params) => {
        const handleClickOpen = (order) => {
          setSelectedOrder(order);
          setOpen(true);
        };

        return (
          <Fab
            onClick={() => handleClickOpen(params.row)}
            color="primary"
            aria-label="Edit"
            className={classes.fab}
          >
            <ClearIcon />
          </Fab>
        );
      }
    }
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const handleTerminateOrder = async () => {
    // @ts-ignore: Object is possibly 'null'.
    await dispatch(terminateOrder(id, selectedOrder.id, selectedOrder.trip_id));
    history.go(0);
  };

  const { orders, loading, success } = useSelector((state) => state.orders);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders(id));
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        {loading && <LoadingComponent />}
        {!loading && success && (
          <Container className={classes.container}>
            <BackNavigationComponent page="Terminate Orders" uri="/" />
            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                components={{ Toolbar: GridToolbar }}
                rowHeight={75}
                rows={orders}
                columns={columns}
              />
            </div>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{'Terminate Order?'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you would like to terminate this order?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleTerminateOrder} color="primary" autoFocus>
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          </Container>
        )}
      </React.Fragment>
    </>
  );
}
